/** Must match Backend/src/lib/broadcastInviteLimits.ts */
export const BROADCAST_INVITE_BATCH_MAX = 50;
